import { createTheme, Shadows } from '@mui/material/styles';
import { lightBlue, red, grey } from '@mui/material/colors';

const shadows = ['none', ...Array.from(Array(24)).map((_, i) => `0 0 ${i + 12}px 0 rgba(0, 0, 20, 0.15)`)] as Shadows;

const theme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
  },
  typography: {
    fontSize: 16,
    fontFamily: [
      '"KoPub Batang"',
      'Noto Serif',
      'serif',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: grey.A700,
        },
        secondary: {
          main: lightBlue.A200,
        },
        error: {
          main: red.A400,
        },
        text: {
          primary: '#2C2B28',
          secondary: '#6B6760',
        },
        background: {
          default: '#FAF9F5',
          paper: '#FFFFFF',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: '#F5F2E8',
        },
        secondary: {
          main: lightBlue.A200,
        },
        error: {
          main: red.A400,
        },
        text: {
          primary: '#E8E6E1',
          secondary: '#9E9A93',
        },
        background: {
          default: '#111111',
          paper: '#1E1E1E',
        },
        divider: 'rgba(255, 255, 255, 0.15)',
      },
    },
  },
  shape: {
    borderRadius: 2.5,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          color: 'var(--mui-palette-text-primary)',
          backgroundColor: 'var(--mui-palette-background-default)',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: 'var(--mui-palette-text-primary)',
        },
      },
    },
  },
  shadows,
});

export default theme;
